import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

class RechargePackage {
  static name () {
    return 'RechargePackage'
  }

  /**
   * Get a list of all recharge packages
   * @param {boolean} activeOnly - Whether to return only active packages
   * @param {number} blId - Business layer ID
   * @returns {Promise<Array>} - List of recharge packages
   */
  static async getList (activeOnly = true, blId) {
    try {
      const params = {
        blId,
        activeOnly
      }
      return await hillo.get(cloudV2Url + 'membership/recharge-packages', params)
    } catch (error) {
      console.error('Error fetching recharge packages:', error)
      throw error
    }
  }

  /**
   * Get a recharge package by ID
   * @param {number} id - Recharge package ID
   * @returns {Promise<Object>} - Recharge package details
   */
  static async get (id) {
    try {
      return await hillo.get(cloudV2Url + `membership/recharge-packages/${id}`)
    } catch (error) {
      console.error(`Error fetching recharge package with ID ${id}:`, error)
      throw error
    }
  }

  /**
   * Add a new recharge package
   * @param {Object} packageData - Recharge package data
   * @returns {Promise<Object>} - Created recharge package
   */
  static async add (packageData) {
    try {
      return await hillo.jsonPost(cloudV2Url + 'membership/recharge-packages/save', packageData)
    } catch (error) {
      console.error('Error adding recharge package:', error)
      throw error
    }
  }

  /**
   * Edit an existing recharge package
   * @param {Object} packageData - Recharge package data with ID
   * @returns {Promise<Object>} - Updated recharge package
   */
  static async edit (packageData) {
    try {
      return await hillo.jsonPost(cloudV2Url + 'membership/recharge-packages/save', packageData)
    } catch (error) {
      console.error(`Error editing recharge package with ID ${packageData.id}:`, error)
      throw error
    }
  }

  /**
   * Delete a recharge package
   * @param {number} id - Recharge package ID
   * @returns {Promise<boolean>} - Whether the deletion was successful
   */
  static async delete (id) {
    try {
      return await hillo.jsonPost(cloudV2Url + `membership/recharge-packages/${id}/delete`, {})
    } catch (error) {
      console.error(`Error deleting recharge package with ID ${id}:`, error)
      throw error
    }
  }
}

export default RechargePackage
